'use strict';

import $ from 'jquery';
import Swal from 'sweetalert2';

const lang = document.documentElement.lang;
const tr = {
  'pt-BR': {
    modal_title: 'Obrigado!',
    modal_text: 'Ação concluída!',
  },
  en: {
    modal_title: 'Thank you!',
    modal_text: 'Action completed!',
  },
  es: {
    modal_title: '¡Gracias!',
    modal_text: '¡Acción completada!',
  },
};

const savedreport = {
  init() {
    $('.js-success').on('click', function () {
      Swal.fire({
        title: tr[lang].modal_title,
        text: tr[lang].modal_text,
        icon: 'success',
      }).then(() => {
        window.location.href = '/minhas-acoes';
      });
    });
  },
};

export default savedreport;
